import { FullLogo, InHomeIcon, InLogoutIcon, JustifyIcon, Logo, PalyListIcon } from 'assets'
import { useOutsideClick } from 'Hooks'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { logoutAction } from 'store/action/AuthRedux'
import { setAllPostDataAction } from 'store/action/instagramDashboard'
import Swal from 'sweetalert2'
import axiosInstance from 'utils/axiosConfig'
import { createImageUrl } from 'utils/createImageUrl'
import { isVideoUrl } from 'utils/isImageOrVideo'

function InSidebar() {
   const navigate = useNavigate()
   const instagramDashboardData = useSelector((state) => state.instagramDashboard)
   const { allPostData } = instagramDashboardData
   const authData = useSelector((state) => state.user)
   const { userData } = authData
   const [isShowMobileMenu, setIsShowMobileMenu] = useState(false)
   const [activeItem, setActiveItem] = useState(null)
   const location = useLocation()
   const onMobileMenu = () => {
      setIsShowMobileMenu(!isShowMobileMenu)
   }
   const ref = useOutsideClick(() => {
      isShowMobileMenu && onMobileMenu()
   })
   const dispatch = useDispatch()

   // batch Post message status call api every 5sec.
   const fetchData = async () => {
      try {
         const response = await axiosInstance.get(`/instagram/post_analysis_status`)

         // ✅ Filter Post that are analyzed
         const successfulPost =
            response.data?.data?.filter((video) => video.is_analyzed === true) || []
         if (successfulPost.length > 0) {
            // ✅ Extract unique posy id
            const uniquePostIc = [...new Set(successfulPost.map((video) => video.thumbnail_url))]
            // ✅ Update allPostData by matching post_id and merging data

            console.log('uniquePostIc', uniquePostIc)

            const updatedAllPostList = allPostData.map((video) => {
               const matched = successfulPost.find((v) => v.id === video.id)
               console.log('matched', matched)
               return matched ? { ...video, ...matched } : video
            })

            // ✅ Dispatch updated data
            dispatch(setAllPostDataAction(updatedAllPostList))

            // ✅ Show SweetAlert
            Swal.fire({
               html: `
    <p>Your posts have been successfully analyzed.</p>
    <p><strong style="font-size: 15px;">Total Posts Analyzed (${uniquePostIc.length}):</strong></p>
    <ul style="display: flex; flex-wrap: wrap; gap: 10px; list-style: none; padding-left: 0; max-height: 200px; overflow-y: auto;">
      ${uniquePostIc
         .map((image, index) => {
            const isVideo = isVideoUrl(image) // Ensure this function exists
            const mediaTag = isVideo
               ? `<video src="${createImageUrl(
                    image
                 )}"  style="width: 150px; height: 150px; object-fit: contain;"></video>`
               : `<img src="${createImageUrl(
                    image
                 )}" alt="InPostImage" class="mw-100" style="width: 150px; height: 150px; object-fit: contain;" />`
            return `<li style="font-size: 13px;" key="${index}">${mediaTag}</li>`
         })
         .join('')}
    </ul>
  `,
               confirmButtonText: 'Okay',
               confirmButtonColor: '#286BFF',
               allowOutsideClick: false,
               theme: 'dark',
               customClass: {
                  popup: 'batch-alter-swal-popup',
                  actions: 'mt-1'
               }
            })
         } else {
            console.log('No analyzed post found.')
         }
      } catch (error) {
         console.error('API error:', error)
      }
   }

   useEffect(() => {
      const interval = setInterval(() => {
         if (allPostData && allPostData.length > 0) {
            fetchData()
         } else {
            console.warn('allPostData is not yet loaded.')
         }
      }, 5000)

      return () => clearInterval(interval)
   }, [allPostData])

   return (
      <>
         <div className="in-mobile-icon top-bar-box justify-icon " onClick={onMobileMenu}>
            <JustifyIcon />
         </div>
         <aside
            ref={ref}
            className={`atenya-side-bar instagram-side-bar ${
               isShowMobileMenu ? 'show-in-mobile-sidebar' : ''
            } `}>
            <div className="logo-wrap">
               <div
                  className="logo-section"
                  onClick={() => {
                     navigate(`/instagram/dashboard/`)
                  }}>
                  <img src={FullLogo} alt="logo" />
               </div>
            </div>

            <div className="in-menu-list">
               <ul>
                  <li
                     className={`in-menu-list-wrap ${
                        location.pathname === '/instagram/dashboard' ? 'active' : ''
                     }`}>
                     <Link
                        to={'/instagram/dashboard'}
                        onClick={onMobileMenu}
                        className="in-icon-name-wrap">
                        <InHomeIcon />
                        <span className="in-menu-name">Dashboard</span>
                     </Link>
                  </li>

                  <li
                     className={`in-menu-list-wrap ${
                        location.pathname === '/instagram/posts-reel' ? 'active' : ''
                     }`}>
                     <Link
                        to={'/instagram/posts-reel'}
                        onClick={onMobileMenu}
                        className="in-icon-name-wrap">
                        <PalyListIcon />
                        <span className="in-menu-name">Posts</span>
                     </Link>
                  </li>

                  <li className="in-menu-list-wrap">
                     <Link
                        to={'#'}
                        onClick={() => {
                           // onMobileMenu()
                           navigate('/instagram/login')
                           dispatch(logoutAction())
                        }}
                        className="in-icon-name-wrap">
                        <InLogoutIcon />
                        <span className="in-menu-name">Logout</span>
                     </Link>
                  </li>
               </ul>
            </div>
         </aside>
      </>
   )
}

export default InSidebar
